module.exports = __webpack_public_path__ + "b751ac189c2346e25792658e0522b480.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2109_teaser_image.jpg
// module id = 603
// module chunks = 0